import { DateRangeType } from '../../types/phlebotomist-dashboard';

export const CAL_PERIOD_MAP: Record<string, DateRangeType> = {
  'registrations-week': 'weekCal',
  'registrations-month': 'monthCal',
  'registrations-quarter': 'quarterCal',
  'registrations-year': 'yearCal',
};

export const REGISTRATION_TABLE_BY_DATE_RANGE: Partial<
  Record<DateRangeType, string>
> = {
  week: 'registrations-week',
  lastWeek: 'registrations-week',
  weekCal: 'registrations-week',
  lastWeekCal: 'registrations-week',
  month: 'registrations-month',
  lastMonth: 'registrations-month',
  monthCal: 'registrations-month',
  lastMonthCal: 'registrations-month',
  quarter: 'registrations-quarter',
  lastQuarter: 'registrations-quarter',
  quarterCal: 'registrations-quarter',
  lastQuarterCal: 'registrations-quarter',
  year: 'registrations-year',
  lastYear: 'registrations-year',
  yearCal: 'registrations-year',
  pYearCal: 'registrations-year',
};

export const STATUS_COLORS = {
  good: { fill: '#52c41a', border: '#389e0d' },
  ok: { fill: '#faad14', border: '#d48806' },
  poor: { fill: '#ff4d4f', border: '#cf1322' },
  delta: {
    positive: '#95de64',
    negative: '#ff7875',
  },
} as const;

export const RETENTION_BREAKPOINTS: [number, number] = [60, 80];
export const DROPOUT_BREAKPOINTS: [number, number] = [5, 15];
export const RATIO_BREAKPOINTS: [number, number] = [33, 66];
export const CHURN_RATE_BREAKPOINTS: [number, number] = [5, 10];
export const SHOW_RATE_BREAKPOINTS: [number, number] = [50, 75];

export const METRIC_HIGHER_IS_BETTER = {
  churn: false,
  dropout: false,
  ratio: false,
  retention: true,
  showRate: true,
} as const;

export const VALID_DATE_RANGES: ReadonlySet<string> = new Set<DateRangeType>([
  'day',
  'yesterday',
  'week',
  'lastWeek',
  'month',
  'lastMonth',
  'quarter',
  'lastQuarter',
  'year',
  'lastYear',
  'dayCal',
  'yesterdayCal',
  'weekCal',
  'lastWeekCal',
  'monthCal',
  'lastMonthCal',
  'quarterCal',
  'lastQuarterCal',
  'yearCal',
  'pYearCal',
  'custom',
]);

export const REGISTRATION_BAR_KEY_MAP = {
  week: 'registrationsWeek',
  month: 'registrationsMonth',
  quarter: 'registrationsQuarter',
  year: 'registrationsYear',
} as const;
